export default __webpack_public_path__ + "static/media/17-HolstebroSandOgGrus.fba8cdc8.png";